import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'picklistLocationTotalQuantity',
})
export class PicklistLocationTotalQuantityPipe implements PipeTransform {
  // TODO: type
  transform(rfqStockLocations :any) :number {
    return rfqStockLocations?.length > 0
      ? rfqStockLocations
          .map((stockLocation :any) => stockLocation.onHandQuantity)
          .reduce((a :any, b :any) => a + b) || 0
      : 0;
  }
}
